module.exports = __webpack_public_path__ + "static/Truck3-ceb9028afc092cf067b5fa9c05e1eb16.png";